/*
 * Módulo de frontend: página "Sabana" en el sidebar (nuevo frontend system).
 * Aparece sola en el menú vía nav.rest() del SidebarContent.
 */
import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import ScheduleIcon from '@material-ui/icons/Schedule';

const sabanaPage = PageBlueprint.make({
  name: 'sabana',
  params: {
    path: '/schedulers',
    title: 'Schedulers',
    icon: <ScheduleIcon />,
    loader: () => import('./SabanaPage').then(m => <m.SabanaPage />),
  },
});

export const sabanaModule = createFrontendModule({
  pluginId: 'app',
  extensions: [sabanaPage],
});
